import { provideHttpClient, withInterceptors } from '@angular/common/http';
import type { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAuth, authInterceptor } from '@auth';
import { provideRewardsContent } from '@icweb-service-marketplace/rewards-content';
import { loyaltyHeadersInterceptor, provideLoyalty } from '@loyalty';
import { provideMonthlyStatementContent } from '@monthly-statement-content';

import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([authInterceptor, loyaltyHeadersInterceptor])),
    provideAuth(),
    provideRewardsContent(),
    provideLoyalty(),
    provideMonthlyStatementContent(),
  ],
};
